<template>
  <div class="">
    <div class="flex items-end">
      <h3 class="flex-grow grow-color-text font-bold text-20 tracking-normal leading-tight pr-2">
        <span class="text-primary">
          {{ $t("Shop ") }}
        </span>
        <span class="text-secondary">{{ $t("+ Save") }}</span>
      </h3>
      <router-link :to="{ name: 'Locations', params: { back: '/locations' } }"
        class="text-14 tracking-normal text-cause_text text-content">
        <span class="flex">
          {{ $t("Details") }}
          <svg class="icon-color back-icon ml-1 feather feather-arrow-right" fill="none" height="24"
            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
            width="24" xmlns="http://www.w3.org/2000/svg">
            <line x1="5" x2="19" y1="12" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </span>
      </router-link>
    </div>
    <p class="text-14 text-subtitle text-text mb-8">
      Get local deals for your generosity
    </p>
    <div class="mt-6">
      <BlogPost post-type="partner" />
    </div>
  </div>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";
import BlogPost from "../Post/BlogPost";

export default {
  name: "Shopandsave",
  components: {
    BlogPost,
    Button
  },
  mixins: [mixins.helpers],
  props: {
    chevronLeft: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {};
  },
  watch: {},
  mounted() { },
  computed: {},
  methods: {}
};
</script>